import { computed } from '@ember/object';
import InductorActualFilterAmplitude from '../common/actual-filter-amplitude';
import * as Complex from '../../../process-data/complex';

export default InductorActualFilterAmplitude.extend({
  c1: null,
  l1: null,
  r1: null,
  complexAlphaMinus: Complex.createComplex(0, 0),
  complexBetaPlus: Complex.createComplex(0, 0),
  complexAlphaPlus: computed('c1', 'l1', 'r1', 'sSquared', 'sImaginary', function () {
    var sSquared = this.sSquared;
    var sImaginary = this.sImaginary;

    var c1 = this.c1;
    var l1 = this.l1;
    var r1 = this.r1;

    var result = Complex.createComplex(0, l1 * sImaginary).divide(
      Complex.createComplex(r1 * l1 * c1 * sSquared + r1, l1 * sImaginary),
    );
    return result;
  }),
  inputImpedance: computed('c1', 'l1', 'r1', 'sImaginary', function () {
    var r1 = this.r1;
    var l1 = this.l1;
    var c1 = this.c1;
    var complexR1 = Complex.createComplex(r1, 0);

    var sImaginary = this.sImaginary;
    var top = Complex.createComplex(l1 / c1, 0);
    var bottom = Complex.createComplex(0, l1 * sImaginary - 1 / (c1 * sImaginary));
    var result = complexR1.plus(top.divide(bottom));
    return result;
  }),
});
